import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LanguageTranslation')
export class LanguageTranslation {

  @JsonProperty('translation_id', Number)
  translationId: number = 0;

  @JsonProperty('translation_key', String)
  translationKey: string = '';

  @JsonProperty('translation_value', String)
  translationValue: string = '';
}
